import ExpandedSideBar from '@/components/sideBar/ExpandedSideBar.vue'
import CompactSideBar from '@/components/sideBar/CompactSideBar.vue'
import { shipmentsSidebarOptions } from '@/modules/shipments-module/components/sidebar/shipments-sidebar-options'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { UIComponentCustomFilterResponse } from '@/api/services/common/ui-component/custom-filter/ui-component-custom-filter.dto'
import { VtCustomFilter } from '@/api/resources/common/shared/models/common.models'
import { ShipmentsGridType } from '@/modules/shipments-module/components/grid/datasources/shipments-grid-datasource-factory'
import { findNodeByPropertyValue } from '@/components/sideBar/sideBarUtils'

export interface ShipmentsCustomFilter extends VtCustomFilter {
    gridType: ShipmentsGridType
}

// TODO: pendent to migrate RenameCustomFilterModal to typescript (component must return ONLY de filter name, not ALL response plus 'label')
export interface CustomFilterRenamed extends UIComponentCustomFilterResponse<ShipmentsCustomFilter> {
    label: string
}

export interface ShipmentsSidebarState {
    componentCode: string
    defaultOption: Nullable<any>
    sidebars: any[]
    sidebar: any
    summaryInterval: StrictNullable<number>
    options: any
    customOptions: UIComponentCustomFilterResponse<ShipmentsCustomFilter>[]
}
export const initialShipmentsSidebarState =
    (): ShipmentsSidebarState => ({
        componentCode: 'uicomponent.shipment.sidepanel',
        defaultOption: null,
        sidebars: [ ExpandedSideBar, CompactSideBar ],
        sidebar: ExpandedSideBar,
        summaryInterval: null,
        options: shipmentsSidebarOptions(),
        customOptions: []
    })

export const shipmentsCompleteArray: any[] =
    shipmentsSidebarOptions().expanded.reduce(
        (prev: any, next: any) => next.children
            ? prev.concat(next.children)
            : prev.concat(next), [])

export const initialShipmentsSelectedOption: any =
    findNodeByPropertyValue('id', 'shipmentsPendingToSend', shipmentsCompleteArray)
